import { RouterView } from "vue-router";
import { LeaseContractRouting } from "./lease-contract/lease-contract.routing";
import { LeasePaymentReqRouting } from "./lease-payment-req/lease-payment-req.routing";
import { LeaseSettlementRouting } from "./lease-settlement/lease-settlement.routing";

export const LeaseConfigRouting = {
  path: "/lease-config",
  name: "lease-config",
  redirect: "/lease-config/lease-contract/list",
  component: RouterView,
  meta: { title: "租赁管理", icon: "zulin" },
  children: [
    ...LeaseContractRouting,
    ...LeaseSettlementRouting,
    ...LeasePaymentReqRouting
  ],
};
